module.exports = __webpack_public_path__ + "static/img/jigou-jiangxi-top.b626bff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-jiangxi-top.png
// module id = TBaO
// module chunks = 2